const accessCommunication = {
    NOTICES_AND_EVENTS: { name: 'Notices and Events', path: '/notices-and-events' },
    NOTICE_LIST: { name: 'Notice', path: '/notice-list' },
    ADD_NOTICE: { name: 'Add Notice', path: '/create-notice' },
    UPDATE_NOTICE: { name: 'Update Notice', path: '/edit-notice' },
    DELETE_NOTICE: { name: 'Delete Notice', path: '/delete-notice' },
    NOTICE_DETAILS: { name: 'Notice Details', path: '/notice-details' },

    POLL_LIST: { name: 'Poll', path: '/poll-list' },
    ADD_POLL: { name: 'Add Poll', path: '/create-poll' },
    UPDATE_POLL: { name: 'Update Poll', path: '/edit-poll' },
    DELETE_POLL: { name: 'Delete Poll', path: '/delete-poll' },
    POLL_DETAILS: { name: 'Poll Details', path: '/poll-details' },

    EVENT_LIST: { name: 'Event', path: '/event-list' },
    ADD_EVENT: { name: 'Add Event', path: '/create-event' },
    UPDATE_EVENT: { name: 'Update Event', path: '/edit-event' },
    DELETE_EVENT: { name: 'Delete Event', path: '/delete-event' },
    EVENT_DETAILS: { name: 'Event Details', path: '/event-details' },
    EVENT_CALENDAR: { name: 'Event Calendar', path: '/event-calendar' },

}

export default accessCommunication;